import { render, staticRenderFns } from "./EmptyStateSVG.vue?vue&type=template&id=3baa03a7"
import script from "./EmptyStateSVG.vue?vue&type=script&lang=js"
export * from "./EmptyStateSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports